import styled from '@emotion/styled';
import { IEnrichedFlight } from '../../../flights/shared/flight/domain/models/IEnrichedFlight';
import TimeCell from './Cells/TimeCell';
import { ArrivalDepartureCell } from './Cells/ArrivalDepartureCell';
import { Color } from '../../../../styles/Color';
import { FlightCell } from './Cells/FlightCell';
import { Css, Responsive, UnstyledLi } from '../../../../ui';
import { AirlineCell } from './Cells/AirlineCell';
import DetailsCell from './Cells/DetailsCell';

interface IFlightSearchRowProps {
	flight: IEnrichedFlight;
}

export function FlightSearchRow({ flight }: IFlightSearchRowProps) {
	return (
		<StyledRow>
			<Cell width={80}>
				<TimeCell
					scheduledTimeStamp={flight.scheduledTimestamp}
					actualTimestamp={flight.actualTimestamp}
				/>
			</Cell>

			<Cell width={110} hideOnMobile>
				<ArrivalDepartureCell arrival={flight.arrival} />
			</Cell>

			<Cell width={270}>
				<FlightCell
					airportDetails={flight.viaAirportDetails}
					airport={flight.viaAirport}
					city={flight.viaCityName}
					codeShareFlightNumber={flight.codeShareFlightNumber}
				/>
			</Cell>

			<Cell width={140} hideOnTablet>
				<AirlineCell
					airlineDetails={flight.airlineDetails}
					icaoOperatingAirline={flight.icaoOperatingAirline}
				/>
			</Cell>

			<Cell width={70}>
				<DetailsCell flight={flight} arrival={flight.arrival} />
			</Cell>
		</StyledRow>
	);
}

export const StyledRow = styled(UnstyledLi)`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${Css.pxToRem(12)};

	background-color: ${Color.PrimaryWhite};
	border-radius: 5px;

	height: max-content;
	width: 100%;
	min-height: ${Css.pxToRem(64)};

	padding: ${Css.pxToRem(8)} ${Css.pxToRem(24)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		align-items: stretch;
		padding: ${Css.pxToRem(16)} ${Css.pxToRem(18)} ${Css.pxToRem(16)}
			${Css.pxToRem(8)};
	}
`;

export const Cell = styled.div<{
	width: number;
	hideOnTablet?: boolean;
	hideOnMobile?: boolean;
}>`
	width: ${({ width }) => Css.pxToRem(width)};
	height: auto;

	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		${({ hideOnTablet }) => hideOnTablet && `display: none`}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		${({ hideOnMobile }) => hideOnMobile && `display: none`}
	}
`;
